import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { WithdrawalInstruction } from '../../../../../models/submissions/withdrawal-instruction';

@Component({
  selector: 'app-vb-payments-withdrawal-details-card',
  templateUrl: './vb-payments-withdrawal-details-card.component.html',
  styleUrls: ['./vb-payments-withdrawal-details-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentsWithdrawalDetailsCardComponent implements OnChanges {
  @Input() withdrawalInstructions: WithdrawalInstruction[] | null = [];

  public displayWithdrawalInstructions: WithdrawalInstruction[] = [];

  public ngOnChanges(): void {
    this.displayWithdrawalInstructions = (this.withdrawalInstructions ?? [])
      .filter(instruction => instruction.percentage > 0)
      .sort((a, b) => a.fund.name.localeCompare(b.fund.name));
  }
}
